import { useContext, useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { UserDataContext } from "../components/UserDataContext";
import VN from "../components/VN";
import { Row, Col, Container } from "react-bootstrap";
import { marginTop, marginBottom } from "../config/layout";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../components/theme";
import { useState } from "react";
import Collapse from "@mui/material/Collapse";
import Alerts from "../components/Alerts";
import {
  Button,
  CircularProgress,
  Box,
  Card,
  CardContent,
  Typography,
  Grid,
  LinearProgress,
  Stack,
} from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { apiRequest } from "../services/apiService";

export default function Menu() {
  const navigate = useNavigate();

  const { userData, setUserData } = useContext(UserDataContext);

  const [showPossibilities, setShowPossibilities] = useState(false);
  const [showApiResponse, setShowApiResponse] = useState(false);
  const [apiResponse, setApiResponse] = useState({});
  const [currentPage, setCurrentPage] = useState(0);

  const [options, setOptions] = useState([]);
  const [selectedItems, setSelectedItems] = useState(new Set());

  const [loadingData, setLoadingData] = useState(true);
  const [isSaving, setIsSaving] = useState(false);

  const groups = useMemo(() => {
    const grouped = options.reduce((acc, item) => {
      if (!acc[item.groupname]) {
        acc[item.groupname] = [];
      }

      acc[item.groupname].push(item);

      return acc;
    }, {});

    return Object.entries(grouped);
  }, [options]);

  const progress = groups.length
    ? ((currentPage + 1) / groups.length) * 100
    : 0;

  const hasNextPage = currentPage < groups.length - 1;
  const hasPrevPage = currentPage > 0;

  const currentGroup = groups[currentPage];

  const toggleItem = (id) => {
    setSelectedItems((prev) => {
      const newSet = new Set(prev);

      if (newSet.has(id)) {
        newSet.delete(id);
      } else {
        newSet.add(id);
      }

      return newSet;
    });
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const optionsResponse = await apiRequest("getpossibilities", "GET");

        console.log("options:", optionsResponse);

        if (Array.isArray(optionsResponse)) {
          setOptions(optionsResponse);
        }
      } catch (err) {
        console.error("Błąd pobierania możliwości:", err);
      }
    };

    if (userData?.userId) {
      fetchData();
    }
  }, [userData]);
  useEffect(() => {
    const fetchUserSelections = async () => {
      if (!userData?.userId) return;

      setLoadingData(true);

      try {
        const response = await apiRequest(
          `get-seeker-possibilities/${userData.userId}`,
          "GET",
        );
        console.log("possibilities: ", response);
        if (response.success && Array.isArray(response.selectedIds)) {
          setSelectedItems(new Set(response.selectedIds.map(Number)));
        }
      } finally {
        setLoadingData(false);
      }
    };

    fetchUserSelections();
  }, [userData]);

  const handleSave = async () => {
    setIsSaving(true);

    try {
      const payload = {
        userId: userData.userId,
        selectedIds: Array.from(selectedItems),
      };

      const response = await apiRequest(
        "save-possibilities-seeker",
        "POST",
        payload,
      );

      setApiResponse(
        response.success
          ? {
              title: "Sukces",
              severity: "success",
              info: "Dane zapisane.",
            }
          : {
              title: "Błąd",
              severity: "warning",
              info: "Nie udało się zapisać.",
            },
      );

      setShowApiResponse(true);
    } finally {
      setIsSaving(false);
    }
  };

  return (
    <div>
      <VN userData={userData} />

      <Container style={{ marginTop: "40px" }}>
        <h1>Poszukiwanie opiekunki</h1>

        <Box mt={4}>
          <Button
            variant="contained"
            size="large"
            fullWidth
            sx={{
              py: 3,
              fontSize: "1.2rem",
              borderRadius: 3,
              textTransform: "none",
            }}
            onClick={() => setShowPossibilities((prev) => !prev)}
          >
            Utwórz zlecenie poszukiwania opiekunki
          </Button>
        </Box>

        <Collapse in={showPossibilities}>
          <Box mt={4}>
            {showApiResponse && <Alerts data={apiResponse} />}

            <Typography variant="h4" mb={1}>
              Preferencje
            </Typography>

            <Typography mb={3} color="text.secondary">
              {userData?.fullName}, {userData?.cityName}
            </Typography>

            <LinearProgress
              variant="determinate"
              value={progress}
              sx={{ mb: 4, height: 8, borderRadius: 4 }}
            />

            <Card sx={{ borderRadius: 4 }}>
              <CardContent>
                {loadingData ? (
                  <Box textAlign="center" py={6}>
                    <CircularProgress />
                    <Typography mt={2}>Ładowanie...</Typography>
                  </Box>
                ) : currentGroup ? (
                  <>
                    <Typography variant="h5" mb={3}>
                      {currentGroup[0]}
                    </Typography>

                    <Grid container spacing={2}>
                      {currentGroup[1].map((item) => {
                        const selected = selectedItems.has(item.id);

                        return (
                          <Grid item xs={12} md={6} key={item.id}>
                            <Card
                              onClick={() => toggleItem(item.id)}
                              sx={{
                                cursor: "pointer",
                                border: selected
                                  ? "2px solid #1976d2"
                                  : "1px solid #ddd",
                                backgroundColor: selected
                                  ? "rgba(25,118,210,0.08)"
                                  : "white",
                                transition: "0.2s",
                                "&:hover": {
                                  transform: "translateY(-2px)",
                                  boxShadow: 3,
                                },
                              }}
                            >
                              <CardContent
                                sx={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: 2,
                                }}
                              >
                                <CheckCircleIcon
                                  color={selected ? "primary" : "disabled"}
                                />

                                <Typography>{item.activity}</Typography>
                              </CardContent>
                            </Card>
                          </Grid>
                        );
                      })}
                    </Grid>

                    <Stack direction="row" spacing={2} mt={4}>
                      <Button
                        variant="outlined"
                        disabled={!hasPrevPage}
                        onClick={() => setCurrentPage((p) => p - 1)}
                      >
                        Wstecz
                      </Button>

                      {hasNextPage ? (
                        <Button
                          variant="contained"
                          onClick={() => setCurrentPage((p) => p + 1)}
                        >
                          Dalej
                        </Button>
                      ) : (
                        <Button
                          variant="contained"
                          color="success"
                          onClick={handleSave}
                          disabled={isSaving}
                        >
                          {isSaving ? (
                            <CircularProgress size={22} color="inherit" />
                          ) : (
                            "Zapisz zmiany"
                          )}
                        </Button>
                      )}
                    </Stack>
                  </>
                ) : (
                  <Typography>Brak danych</Typography>
                )}
              </CardContent>
            </Card>
          </Box>
        </Collapse>
      </Container>
    </div>
  );
}
